var tw_button_ask_a_question;
var tw_product_addons_ask_a_question;

var tw_button_share;
var tw_product_addons_share;
window.addEventListener('DOMContentLoaded', function() {
  
  tw_button_ask_a_question = document.querySelector('button-ask-a-question');
  tw_product_addons_ask_a_question = document.querySelector('.product-addons__ask-question');
  if(tw_button_ask_a_question && tw_product_addons_ask_a_question) {
    tw_button_ask_a_question.addEventListener('click', function() {
      tw_product_addons_ask_a_question.click();
    });
  }

  tw_button_share = document.querySelector('button-share');
  tw_product_addons_share = document.querySelector('.product-addons__share');
  if(tw_button_share && tw_product_addons_share) {
    tw_button_share.addEventListener('click', function() {
      tw_product_addons_share.click();
    });
  }
  
});